"use client";

import { SLLink } from "@/components/i18n/SLLink";
import { SLLazyBackgroundVideo } from "@/components/other/SLLazyBackgroundVideo";
import { useMessages } from "@/lib/i18n/useMessages";
import { slRoutes } from "@/lib/slRoutes";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import Image from "next/image";

export const SLFooter = () => {
  const theme = useTheme();
  const m = useMessages();

  const footerLinks = [
    { label: m.nav.blog, href: slRoutes.blog },
    { label: m.footer.imprint, href: slRoutes.imprint },
    { label: m.footer.privacy, href: slRoutes.privacy },
  ];

  return (
    <Stack
      component="footer"
      role="contentinfo"
      sx={{
        mt: 0,
        mb: 0,
        mx: 0,
        width: "100%",
        height: "100vh",
        backgroundColor: "transparent",
        position: "relative",
        p: 10,
        pt: 30,
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <SLLazyBackgroundVideo />
      <Stack
        component="nav"
        aria-label="Footer navigation"
        direction="column"
        gap={2}
        justifyContent="center"
        alignItems="center"
        sx={{
          color: theme.palette.secondary.main,
          zIndex: 100,
        }}
      >
        {footerLinks.map((link) => (
          <SLLink
            href={link.href}
            key={link.label}
            style={{ textDecoration: "none" }}
          >
            <Typography
              component="span"
              color={theme.palette.secondary.main}
              variant="h6"
            >
              {link.label}
            </Typography>
          </SLLink>
        ))}
      </Stack>
      <Box
        sx={{
          width: "100%",
          height: "20%",

          position: "relative",
        }}
      >
        <Image
          src="/logo/white.svg"
          alt="Solving Legal - Rechtsanwaltskanzlei"
          fill={true}
        />
      </Box>
    </Stack>
  );
};
